import {VFC} from "react"
import {SessionNotFound} from "../../components/errors/session-not-found"

export const NotFound: VFC = () => {
    return <SessionNotFound />
}
